module.exports = __webpack_public_path__ + "static/img/bb.4fc793f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/bb.png
// module id = b3Up
// module chunks = 0